/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: endpoints.ts
 * Project: mle-client
 * Committed last: 2021/11/12 @ 847
 * ---
 */

/**
 * Evita l'utilizzo di stringhe hard-coded per le chiamate HTTP all'authProvider
 * @enum
 */
export enum MleAuthProviderEndpoints {
  LOCAL_LOGIN = '/auth/login-local',
  LOCAL_REGISTER = '/auth/register-local',
  ME = '/auth/me',
  RESET_PWD_TOKEN = '/auth/me/reset-token',
  LOGOUT = '/auth/logout',
  REFRESH = '/auth/refresh',
  LINK_INSTANCE = '/auth/me/link-instance'
}
